import React from "react";
import i18n from "../i18n";

export const rewriteSummerReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.rewrite-summer.mongolia.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.rewrite-summer.mongolia.description"),
          }}
        />
      );
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/61098854570380641_3ec45f7e9e_k.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.4) 77.26%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.rewrite-summer.dolomites.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.rewrite-summer.dolomites.description"),
          }}
        />
      );
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/95638854822107654_9ac21e3496_k.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.312) 18.89%, rgba(0, 0, 0, 0) 33.94%, rgba(0, 0, 0, 0) 53.36%, rgba(0, 0, 0, 0.468) 75.46%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.rewrite-summer.nepal.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.rewrite-summer.nepal.description"),
          }}
        />
      );
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/68961954979105967_8e49ec02de_k.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 21.05%, rgba(0, 0, 0, 0) 29.88%, rgba(0, 0, 0, 0) 68.91%, rgba(0, 0, 0, 0.5) 81.27%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.rewrite-summer.africa.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.rewrite-summer.africa.description"),
          }}
        />
      );
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/46602554628114754_c2d0226281_k.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.29) 15.56%, rgba(0, 0, 0, 0) 23.15%, rgba(0, 0, 0, 0) 69.8%, rgba(0, 0, 0, 0.58) 74.58%)",
  },
];

export const worldWonderReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.world-wonders.world_festivals.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.world-wonders.world_festivals.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/ww-worldnomad.webp",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.4) 77.26%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.world-wonders.edge_of_the_world.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t(
              "landing.destination.reasons.world-wonders.edge_of_the_world.description"
            ),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/ww-antarctica.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 21.05%, rgba(0, 0, 0, 0) 29.88%, rgba(0, 0, 0, 0) 68.91%, rgba(0, 0, 0, 0.5) 81.27%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.world-wonders.wild_beasts.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.world-wonders.wild_beasts.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/ww-gorilla.jpg",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.29) 15.56%, rgba(0, 0, 0, 0) 23.15%, rgba(0, 0, 0, 0) 69.8%, rgba(0, 0, 0, 0.58) 74.58%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.world-wonders.ancient_world.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.world-wonders.ancient_world.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/ww-machu.webp",
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.312) 18.89%, rgba(0, 0, 0, 0) 33.94%, rgba(0, 0, 0, 0) 53.36%, rgba(0, 0, 0, 0.468) 75.46%)",
  },
];

export const mongoliaDestinationReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.mongolia.gallop_fields.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.mongolia.gallop_fields.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    reviewer: {
      name: "Alex",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/6fb7b0d436666805bcb8ba02bcd62d19-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.4) 77.26%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.mongolia.nomadic_yurt.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.mongolia.nomadic_yurt.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_yurt_pic.png",
    reviewer: {
      name: "Alicia",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/34d112c61000cb4a073f21e19fe48810-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 21.05%, rgba(0, 0, 0, 0) 29.88%, rgba(0, 0, 0, 0) 68.91%, rgba(0, 0, 0, 0.5) 81.27%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.mongolia.gobi_desert.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.mongolia.gobi_desert.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_desert_pic.png",
    reviewer: {
      name: "Jason Hee",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/6122fc593b17cf38585ce5f7c9840a24-s",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.29) 15.56%, rgba(0, 0, 0, 0) 23.15%, rgba(0, 0, 0, 0) 69.8%, rgba(0, 0, 0, 0.58) 74.58%)",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.mongolia.rich_culture.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.mongolia.rich_culture.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_eagle_pic.png",
    reviewer: {
      name: "Tan",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/1117d10d45e1e185871d5f51c42903c7-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.312) 18.89%, rgba(0, 0, 0, 0) 33.94%, rgba(0, 0, 0, 0) 53.36%, rgba(0, 0, 0, 0.468) 75.46%)",
  },
];

export const japowDestinationReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow.powder_playgrounds.title");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1804693image_2026-06-02_18-51-57.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow.onsen_towns.title");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/181869588d34336a588a3b44c7a087c89ab069-1024x768.jpg",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow.tree_runs.title");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1003260image_2025-05-28_16-31-15.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow.devour_ramen.title");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1841288image_2026-06-02_18-51-44.png",
  },
];

export const weekendDestinationReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend.push_limits.title");
    },
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/rockurbody.mov",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/image_2025-09-04_18-42-08.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend.break_free.title");
    },
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/weekend_short_1.mov",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/image_2025-09-04_01-22-04.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend.reconnect.title");
    },
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/weekend_short_2.mov",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/image_2025-09-04_01-22-31.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend.feel_rush.title");
    },
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/weekend_short_3.mov",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/image_2025-09-04_01-23-11.png",
  },
];

export const japowWhyUsReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow_why_us.hosted_experience.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t(
              "landing.destination.reasons.japow_why_us.hosted_experience.description"
            ),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/187368720250528-161924.mp4",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow_why_us.push_boundaries.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.japow_why_us.push_boundaries.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_secure_vid_2.mov",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow_why_us.action_packed.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.japow_why_us.action_packed.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_professional_vid.mov",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.japow_why_us.beyond_snow.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.japow_why_us.beyond_snow.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc: "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_community_vid.mov",
  },
];

export const weekendPassExplained = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend_pass.four_adventures.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.weekend_pass.four_adventures.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/58de5a9e49e63bd2dcfb6c2cb536ba7a-l",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend_pass.valid_two_years.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.weekend_pass.valid_two_years.description"),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/d5d8ab3d87be8880c74cd3eab2b621da-oxl",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.weekend_pass.non_transferrable.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t(
              "landing.destination.reasons.weekend_pass.non_transferrable.description"
            ),
          }}
        />
      );
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/06c64d33652fdbc4fcc5d6ec73266ad6-xl",
  },
];

export const japowReviews = [
  {
    get title() {
      return i18n.t("landing.destination.reviews.japow.riding_level.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.japow.riding_level.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1082723IMG_6463.jpg",
    reviewer: {
      name: "Amrbose",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/0d07f741f72e5d78fe4c96c102634751-s",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.japow.people_met.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.japow.people_met.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1261057IMG_6462.jpg",
    reviewer: {
      name: "Kelly",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/7684f4a6151b6dea8107c670fe897572-s",
    },
  },

  {
    get title() {
      return i18n.t("landing.destination.reviews.japow.multiple_resorts.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.japow.multiple_resorts.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/717358image_2025-05-28_19-57-32.png",
    reviewer: {
      name: "Azreena",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/dfe71355629c283955562229e4eee433-s",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.japow.night_skiing.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.japow.night_skiing.description");
    },
    thumbnailSrc:
      "https://image.kkday.com/v2/image/get/w_960%2Cc_fit%2Cq_55%2Ct_webp/s1.kkday.com/product_156189/20231124095758_aTWrC/jpg",
    reviewer: {
      name: "Evan",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/b0e261119c7466b1714bceb7ae6d8fca-s",
    },
  },
];

export const weekendReviews = [
  {
    get title() {
      return i18n.t("landing.destination.reviews.weekend.amazing.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.weekend.amazing.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/7c6844fe83a82c2b525f9998dd5acd97-xl",
    reviewer: {
      name: "Victoria",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/692b81903ef15fad5c68c049fa270d91-s",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.weekend.action_packed.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.weekend.action_packed.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/1813f56e6e9e5f9a4da17120e14940c8-xl",
    reviewer: {
      name: "Wee Kai",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/a68f03c2001105c48add50b4e12e28d5-s",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.weekend.get_dirty.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.weekend.get_dirty.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/a31b6b75350a33ce196eb45c4397b4dd-xl",
    reviewer: {
      name: "Jit Yang",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/0878065530c307178173b94e56dd8072-s",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.weekend.good_weekend.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.weekend.good_weekend.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/fc6ef61d29b46774f0e39defc1d47edc-xl",
    reviewer: {
      name: "Wei",
      profilePictureSrc: "https://d1puf2nnbcyl9q.cloudfront.net/a85917653ff6ed4f2df46fa340a2d115-s",
    },
  },
];

const createFaqs = (faqKeys) =>
  faqKeys.map((key) => ({
    key,
    get question() {
      return i18n.t(`landing.faqs.questions.${key}.question`);
    },
    get answer() {
      if (key === "travel_insurance") {
        return (
          <>
            <p>
              <p className="tw-mb-2 tw-font-bold">
                {i18n.t(`landing.faqs.questions.${key}.answer_title1`)}
              </p>
              <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail1`)}</p>
            </p>{" "}
            <p>
              <p className="tw-mb-2 tw-mt-2 tw-font-bold">
                {i18n.t(`landing.faqs.questions.${key}.answer_title2`)}
              </p>
              <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail2`)}</p>
            </p>
          </>
        );
      }

      return (
        <p>
          <p className="tw-mb-2 tw-font-bold">
            {i18n.t(`landing.faqs.questions.${key}.answer_title`)}
          </p>
          <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail`)}</p>
        </p>
      );
    },
  }));

const japowFaqKeys = [
  "what_included_snow",
  "lessons_taught_by",
  "equipment_rental",
  "what_to_bring",
  "book_flights",
  "cancellation",
  "travel_insurance",
];

const weekendPassFaqKeys = [
  "weekend_pass_how_to_use",
  "weekend_pass_last_day_usage",
  "weekend_pass_cancel_trip",
  "weekend_pass_cancel_counted_as_use",
  "what_included",
  "cancellation",
  "travel_insurance",
  "people_join",
  "book_flights",
];

export const japowFaqs = createFaqs(japowFaqKeys);
export const weekendPassFaqs = createFaqs(weekendPassFaqKeys);

export const leaderDestinationReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.leader.high_success.title");
    },
    get description() {
      return i18n.t("landing.destination.reasons.leader.high_success.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_eagle_pic.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.leader.short_commitment.title");
    },
    get description() {
      return i18n.t("landing.destination.reasons.leader.short_commitment.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_yurt_pic.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.leader.manageable_scope.title");
    },
    get description() {
      return i18n.t("landing.destination.reasons.leader.manageable_scope.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_desert_pic.png",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.leader.smaller_groups.title");
    },
    get description() {
      return i18n.t("landing.destination.reasons.leader.smaller_groups.description");
    },
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
  },
];

export const leaderReviews = [
  {
    get title() {
      return i18n.t("landing.destination.reviews.leader.helping_others.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.leader.helping_others.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/236703hike-trip-lead.jpg",
    reviewer: {
      name: "Markus",
      profilePictureSrc:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/236703hike-trip-lead.jpg",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.leader.new_experience.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.leader.new_experience.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/277039larry-lead-trip.jpg",
    reviewer: {
      name: "Larry",
      profilePictureSrc:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/277039larry-lead-trip.jpg",
    },
  },
  {
    get title() {
      return i18n.t("landing.destination.reviews.leader.diving_leadership.title");
    },
    get description() {
      return i18n.t("landing.destination.reviews.leader.diving_leadership.description");
    },
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/161077trip-lead-dive.jpg",
    reviewer: {
      name: "Shawn",
      profilePictureSrc:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/161077trip-lead-dive.jpg",
    },
  },
];

export const leaderFaqs = [
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.book_trip.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.book_trip.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.training_programme.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.training_programme.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.leader_credits.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.leader_credits.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.accept_no_book.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.accept_no_book.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.trips_free.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.trips_free.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.need_to_pay.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.need_to_pay.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.discount_example.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.discount_example.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.earn_credits.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.earn_credits.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.why_pay.question");
    },
    get answer() {
      return <p>{i18n.t("landing.destination.faqs.leader.why_pay.answer")}</p>;
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.leader.contact_questions.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.leader.contact_questions.answer"),
          }}
        />
      );
    },
  },
];

export const europeDestinationReasons = [
  {
    get title() {
      return i18n.t("landing.destination.reasons.europe.group_chat_offline.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.europe.group_chat_offline.description"),
          }}
        />
      );
    },
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1772166097368_1%20Time%20to%20take%20the%20Group%20Chat%20offline%20%281%29.mp4",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/europe-reason-1-thumb.jpg",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.europe.adult_exchange.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.europe.adult_exchange.description"),
          }}
        />
      );
    },
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1772166665982_1772166574313_2AdultExchange%281%29.mp4",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/europe-reason-2-thumb.jpg",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.europe.life_slows_down.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.europe.life_slows_down.description"),
          }}
        />
      );
    },
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1772166543627_3%20Life%20slows%20down%20%281%29.mp4",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/europe-reason-3-thumb.jpg",
  },
  {
    get title() {
      return i18n.t("landing.destination.reasons.europe.before_life_serious.title");
    },
    get description() {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.reasons.europe.before_life_serious.description"),
          }}
        />
      );
    },
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1772166562795_4+before+life+too+serious+%281%29.mp4",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/europe-reason-4-thumb.jpg",
  },
];

export const europeFaqs = [
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.group_discount.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.group_discount.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.lucky_draw_winners.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.lucky_draw_winners.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.voucher_and_group.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.voucher_and_group.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.what_included.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.what_included.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.cancellation_policy.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.cancellation_policy.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.flights_insurance.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.flights_insurance.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.sotravel_travelers.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.sotravel_travelers.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.guide_vs_leader.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.guide_vs_leader.answer"),
          }}
        />
      );
    },
  },
  {
    get question() {
      return i18n.t("landing.destination.faqs.europe.when_book_flights.question");
    },
    get answer() {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: i18n.t("landing.destination.faqs.europe.when_book_flights.answer"),
          }}
        />
      );
    },
  },
];

// Aurora Promise campaign (Jul 2026) — copy lives under campaign.aurora.* in all
// three locales (en / zh-Hant-TW / zh-Hans-CN).
// Thumbnails reuse each aurora project's hero image (projects.main_images[0]); the PDF
// does not call out dedicated assets for this section, so we borrow what already exists
// for the featured destinations rather than shipping blank tiles.
const AURORA_REASON_THUMBNAILS = {
  solo_friendly:
    "https://d1puf2nnbcyl9q.cloudfront.net/2026-07-24T05:33:35.711Z2025-11-30T13_57_02.311ZIMG_5429.jpeg", // Norway Northern Lights
  semi_self_guided:
    "https://d1puf2nnbcyl9q.cloudfront.net/2025-11-25T05:07:08.382Zkatlatrack_tours_Katla_5.jpeg", // Iceland Explorer
  fun_companions: "https://d1puf2nnbcyl9q.cloudfront.net/2025-12-11T04:06:34.042Zicebreaker2.webp", // Swedish Lapland
};

const auroraReasonKeys = ["solo_friendly", "semi_self_guided", "fun_companions"];
export const auroraDestinationReasons = auroraReasonKeys.map((key) => ({
  get title() {
    return i18n.t(`campaign.aurora.reasons.${key}.title`);
  },
  get description() {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: i18n.t(`campaign.aurora.reasons.${key}.description`),
        }}
      />
    );
  },
  videoSrc: null,
  thumbnailSrc: AURORA_REASON_THUMBNAILS[key],
  gradient:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.5) 77.26%)",
}));

// Aurora Promise FAQ — doubles as the campaign's terms & conditions section.
const auroraFaqKeys = [
  "refund_how",
  "eligibility",
  "sighting_definition",
  "refund_form",
  "guarantee_vs_nature",
  "why_confident",
  "flights_excluded",
];
export const auroraFaqs = auroraFaqKeys.map((key) => ({
  get question() {
    return i18n.t(`campaign.aurora.faqs.${key}.question`);
  },
  get answer() {
    return (
      <p
        dangerouslySetInnerHTML={{
          __html: i18n.t(`campaign.aurora.faqs.${key}.answer`),
        }}
      />
    );
  },
}));
